import React, { useState, useRef, useEffect } from 'react'
import XLSX from 'xlsx'
import { Col, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ButtonGroup, Button } from '@material-ui/core'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useSelector } from 'react-redux'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'

import 'react-datepicker/dist/react-datepicker.css'
import './styles/datepicker.css'
import {
    clientId,
    clientIdKarri,
    clientIdLlego,
    clientSecret,
    clientSecretKarri,
    clientSecretLlego,
    appName,
    appUrl,
    urlApiFunctionClientes,
    urlApiCierre,
    urlApiFunctionPlanning,
    urlApiPrepInfo,
    urlApiPy,
    appVersion
} from '../../shared/helpers/api/urls'

import { useGuias } from '../Mantenedores/hooks/useGuias'
import { getLocalesByCliente } from '../../shared/helpers/api/mantenedores/generalesCrud'

registerLocale('es', es)

const SheetJSFT = ['xlsx']
    .map(function (x) {
        return '.' + x
    })
    .join(',')

// ============================================================
// FEATURE FLAG: SELECCIÓN DE LOCAL
// ============================================================
// Para activar la funcionalidad de selección de local por cliente,
// cambiar HABILITAR_SELECCION_LOCAL a true
// Para desactivarla y usar el flujo directo de subida de archivo,
// cambiar HABILITAR_SELECCION_LOCAL a false
const HABILITAR_SELECCION_LOCAL = false;
// ============================================================

// eslint-disable-next-line no-use-before-define
const UploadFile = ({ path, titulo, client, tipoOperacion, loading, setLoading }) => {
    const { user: currentUser } = useSelector(state => state.auth)
    const MySwal = withReactContent(Swal)
    const [files, setFiles] = useState([])
    const [excelData, setExcelData] = useState(null)
    const [Enviar, setEnviar] = useState(false)
    const [recibido, setRecibido] = useState(false)
    
    // Estados para funcionalidad de selección de local (FEATURE FLAG)
    const [locales, setLocales] = useState([])
    const [localSeleccionado, setLocalSeleccionado] = useState(null)
    const [mostrarSelectorLocal, setMostrarSelectorLocal] = useState(false)
    const [totalLocales, setTotalLocales] = useState(0)

    const { handleCreateParis } = useGuias(); // Hook para procesar Paris

    useEffect(() => {
        setFiles([])
        setEnviar(false)
        setRecibido(false)
        setLocalSeleccionado(null)
        setMostrarSelectorLocal(false)
        setTotalLocales(0)
        
        // Cargar locales solo cuando es operación de recepción Y la feature está habilitada
        if (HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion' && client && client !== '') {
            cargarLocalesCliente()
        }
    }, [titulo, client, tipoOperacion])

    const cargarLocalesCliente = async () => {
        setLoading(true)
        try {
            const response = await getLocalesByCliente(currentUser, client)
            if (response.success && response.data) {
                setLocales(response.data)
                setTotalLocales(response.total || response.data.length)
                setMostrarSelectorLocal(true)
            } else {
                handleError(
                    response.error || 'No se pudieron cargar los locales del cliente',
                    'Error',
                    'error'
                )
            }
        } catch (error) {
            console.error('Error al cargar locales:', error)
            handleError('Error al cargar los locales del cliente', 'Error', 'error')
        }
        setLoading(false)
    }

    const handleError = (mensaje, titulo, tipo) => {
        MySwal.fire({
            title: titulo,
            icon: tipo,
            html: `${mensaje}`,
            confirmButtonText: 'Aceptar'
        }).then(() => {
            window.location.reload()
        })
    }

    const handleSuccess = mensaje => {
        MySwal.fire({
            title: 'Éxito',
            icon: 'success',
            html: `${mensaje}`,
            confirmButtonText: 'OK',
            confirmButtonColor: '#009B78',
            showDenyButton: false,
            customClass: {
                confirmButton: 'spread-font spread-width-100'
            }
        }).then(result => {
            if (result.isConfirmed) {
                window.location.reload()
            } else window.location.href = '/fist-mile'
        })
    }

    const formatDate = (date, format) => {
        const d = new Date(date)
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        const year = d.getFullYear()
        let dateFormated = ''

        if (month.length < 2) {
            month = '0' + month
        }
        if (day.length < 2) {
            day = '0' + day
        }

        if (format === 'us') dateFormated = [year, month, day].join('-')
        else if (format === 'es') dateFormated = [day, month, year].join('-')
        else dateFormated = [day, month, year].join('-')

        return dateFormated
    }

    const handleFile = e => {
        setLoading(true)
        const files = e.target.files
        if (files && files[0]) {
            setFiles(files)
        }
        const f = files[0]

        const reader = new FileReader()
        reader.onload = function (event) {
            const data = event.target.result
            const readedData = XLSX.read(data, { type: 'binary' })
            const wsname = readedData.SheetNames[0]
            const ws = readedData.Sheets[wsname]

            /* Convert array to json */
            const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 })
            setExcelData(dataParse)
        }
        reader.readAsBinaryString(f)

        setLoading(false)
        setEnviar(true)
    }

    const processExcelData = excelData => {
        let conteoTotal = 0
        let conteoIndex = 0
        let conteo = 0
        let guias = []

        excelData.forEach((value, index) => {
            if (index == 0) {
                if (value[0] != 'Conteo Total MINI') {
                    throw new Error('Formato del archivo incorrecto')
                }
            }
            // conteo para mini
            if (index > 2) {
                if (value[0] !== undefined && value[0] !== '') {
                    conteoTotal += 1
                    if (guias[conteoIndex] === undefined) guias[conteoIndex] = ''
                    guias[conteoIndex] += value[0] + ','
                    conteo += 1
                    if (conteo === 200) {
                        guias[conteoIndex] = guias[conteoIndex].slice(0, -1)
                        conteo = 0
                        conteoIndex += 1
                    }
                }
            }
            // conteo para medium
            if (index > 2) {
                if (value[2] !== undefined && value[2] !== '') {
                    conteoTotal += 1
                    if (guias[conteoIndex] === undefined) guias[conteoIndex] = ''
                    guias[conteoIndex] += value[2] + ','
                    conteo += 1
                    if (conteo === 200) {
                        guias[conteoIndex] = guias[conteoIndex].slice(0, -1)
                        conteo = 0
                        conteoIndex += 1
                    }
                }
            }
        })

        if (guias.length === 0) {
            throw new Error('No puede venir excel vacío')
        }
        guias[conteoIndex] = guias[conteoIndex].slice(0, -1)

        return { guias, conteoTotal }
    }

    const procesarData = async () => {
        setLoading(true)
        let conteoCorrectos = 0
        let errores = []
        let fetchData = []
        let url = ''
        let headers = {}

        try {
            const { guias, conteoTotal } = processExcelData(excelData)

            if (path === 'recepcionShipit1') {
                guias.forEach((value, index) => {
                    fetchData[index] = {
                        body: {
                            bulto: value,
                            status: 0,
                            estado: 'Recepcionado Correctamente'
                        }
                    }
                })
                url = 'https://api-shipit.azurewebsites.net/cambioEstadoMasivo'
                headers = {
                    'Content-Type': 'application/json',
                    client_id: '54f8892fddd9d9b45031b8c6d441a2',
                    client_secret: 'VZi7DnrRunfUKgJ6rgKzDDoG7ebrF4XK1Qlgo9KEl7I'
                }
            } else if (
                path === 'recepcionKarri' ||
                path === 'recepcionLlego' ||
                path === 'recepcionShipit' ||
                path === 'recepcionWalmart' ||
                path === 'recepcionDimeiggs' ||
                path === 'recepcionPruebas' ||
                path === 'recepcionRipley'
            ) {
                guias.forEach((value, index) => {
                    fetchData[index] = {
                        body: {
                            guias: value,
                            estado: 'Recepcionado',
                            sub_estado: 'Recepcionado',
                            cliente: client,
                            event: 'massive_update',
                            local_id: localSeleccionado?.id || null
                        }
                    }
                })
                url = urlApiFunctionClientes + 'api/pedidos'

                let client_id = process.env.REACT_APP_CLIENT_ID
                let client_secret = process.env.REACT_APP_CLIENT_SECRET

                const auth = 'Basic ' + btoa(client_id + ':' + client_secret)
                headers = {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST',
                    'Content-Type': 'application/json',
                    Authorization: auth
                }
            } else if (path === 'recepcionParis') {
                guias.forEach((value, index) => {
                    fetchData[index] = {
                        body: {
                            guias: value,
                            estado: 'Recepcionado',
                            sub_estado: 'Recepcionado',
                            cliente: client,
                            event: 'massive_update',
                            local_id: localSeleccionado?.id || null
                        }
                    }
                })
                url = urlApiFunctionClientes + 'api/pedidos'

                let client_id = process.env.REACT_APP_CLIENT_ID
                let client_secret = process.env.REACT_APP_CLIENT_SECRET

                const auth = 'Basic ' + btoa(client_id + ':' + client_secret)
                headers = {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST',
                    'Content-Type': 'application/json',
                    Authorization: auth
                }
            }

            const errores_fetch = []
            for (const value of fetchData) {
                try {
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(value)
                    })
                    // console.log('response:', response)
                    let responseJson
                    try {
                        responseJson = await response.json()
                    } catch (jsonError) {
                        throw new Error('Invalid JSON response')
                    }
                    // console.log('response:', response)
                    // console.log('responseJson:', responseJson)

                    if (response.status === 200) {
                        if (Array.isArray(responseJson)) {
                            // console.log('responsejson es array');
                            responseJson.forEach(resValue => {
                                if (resValue.status === 200) {
                                    conteoCorrectos += resValue.conteo
                                    resValue.errores.forEach(error => {
                                        errores.push(error)
                                    })
                                }
                            })
                        } else {
                            // console.log('responsejson no es array');
                            const parsedMessage = JSON.parse(responseJson)
                            conteoCorrectos += parsedMessage.conteo
                            parsedMessage.errores.forEach(error => {
                                errores.push(error)
                            })
                        }
                    } else {
                        console.log('responseJson: ' + responseJson.msg)
                        errores_fetch.push(responseJson)
                    }
                } catch (error) {
                    console.log('error')
                    console.log(error)
                    errores_fetch.push(error)
                }
            }

            if (conteoCorrectos === conteoTotal) {
                handleSuccess(`Se han procesado ${conteoTotal} guías
                <br>
                Se procesaron ${conteoCorrectos} guías correctamente
                <br>
                Se encontraron ${errores.length} errores
                <br>
                <br>
                <b>Errores en pistoleo:</b>
                <br>
                ${errores.join('<br>')}
                `)
            } else {
                handleError(
                    `Se han procesado ${conteoTotal} guías
                <br>
                Se procesaron ${conteoCorrectos} guías correctamente
                <br>
                Se encontraron ${errores.length} errores
                <br>
                <br>
                <b>Errores en pistoleo:</b>
                <br>
                ${errores.join('<br>')}
                <br>
                Se encontraron ${errores_fetch.length} errores en el servidor
                `,
                    'Error',
                    'error'
                )
            }
        } catch (error) {
            handleError(error.message, 'Error', 'error')
        }
        setLoading(false)
    }

    const fetchClientDataMassive = async client => {
        setLoading(true)
        const url = urlApiFunctionClientes + 'api/get_pedidos_externos'
        const client_id = process.env.REACT_APP_CLIENT_ID
        const client_secret = process.env.REACT_APP_CLIENT_SECRET

        const auth = 'Basic ' + btoa(client_id + ':' + client_secret)
        const headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST',
            'Content-Type': 'application/json',
            Authorization: auth
        }

        let body = null
        if (client.toUpperCase() === 'KARRI' || client.toUpperCase() === 'RIPLEY') {
            try {
                const { guias } = processExcelData(excelData)
                body = { bultos: guias.join(',').split(',') }
            } catch (error) {
                handleError(error.message, 'Error', 'error')
                setLoading(false)
                return
            }
        }

        const response = await fetch(`${url}?cliente=${client}&modo=masivo`, {
            method: 'POST',
            headers: headers,
            body: body ? JSON.stringify(body) : undefined
        })
        const data = await response.json()
        if (response.status !== 200) {
            let errorMessage = 'Error al obtener datos'
            try {
                if (typeof data.message === 'string' && data.message.trim().startsWith('{')) {
                    try {
                        const parsedMessage = JSON.parse(data.message)
                        errorMessage = parsedMessage.result?.message || errorMessage
                    } catch (parseError) {
                        console.error('Failed to parse error message:', parseError)
                        errorMessage = data.message || errorMessage
                    }
                } else {
                    errorMessage = data.message || errorMessage
                }
            } catch (e) {
                console.error('Failed to process error message:', e)
            }
            handleError(errorMessage, 'Error', 'error')
            setLoading(false)
            return
        }
        handleSuccess(`Se ha procesado la carga de ${client}
            <br>
            Recordar que ha comenzado el proceso, puede tomar unos minutos
            <br>
            Intentar la recepción en <strong>10 minutos</strong> para ver los cambios
            `)

        setLoading(false)
    }

    const processParisData = async () => {
        setLoading(true)
        const body = {
            estado: 'Recepcionado',
            sub_estado: 'Recepcionado',
            cliente: client,
            event: 'create_orders_paris',
            local_id: localSeleccionado?.id || null
        }

        try {
            const response = await handleCreateParis(body, files)
            console.log('response:', response)
            // handleCreateParis ya maneja el loading, pero aquí puedes mostrar el swal según la respuesta
            if (response && response.success) {
                handleSuccess(response.message)
            } else {
                handleError(response?.error || 'Error al procesar guías de Paris', 'Error', 'error')
            }
        } catch (error) {
            handleError(error.message, 'Error', 'error')
        }
        setLoading(false)
    }

    return (
        <Col className="text-center align-self-center justify-content-md-center">
            {(path === 'recepcionShipit' ||
                path === 'recepcionKarri' ||
                path === 'recepcionLlego' ||
                path === 'recepcionPruebas' ||
                path === 'recepcionRipley' ||
                path === 'recepcionWalmart' ||
                path === 'recepcionDimeiggs' ||
                path === 'recepcionParis' ||
                path === 'faltantesRipley' ||
                path === 'faltantesKarri') && (
                <>
                    {/* ============================================================ */}
                    {/* SELECTOR DE LOCAL - FEATURE FLAG */}
                    {/* Solo se muestra si HABILITAR_SELECCION_LOCAL = true */}
                    {/* ============================================================ */}
                    
                    {/* Selector de Local - Solo para operaciones de recepción */}
                    {HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion' && mostrarSelectorLocal && !localSeleccionado && (
                        <div className="mb-4">
                            <h5 className="mb-3">
                                Seleccione el local de recepción: 
                                <span style={{ 
                                    marginLeft: '10px',
                                    padding: '4px 12px',
                                    backgroundColor: 'rgb(0, 155, 120)',
                                    color: 'white',
                                    borderRadius: '20px',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}>
                                    {totalLocales} {totalLocales === 1 ? 'local' : 'locales'}
                                </span>
                            </h5>
                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <ButtonGroup orientation="vertical" style={{ width: '100%' }}>
                                    {locales.map((local) => (
                                        <div
                                            key={local.id}
                                            onClick={() => setLocalSeleccionado(local)}
                                            style={{
                                                padding: '16px',
                                                marginBottom: '12px',
                                                backgroundColor: '#fff',
                                                border: '2px solid #e0e0e0',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = 'rgb(0, 155, 120)';
                                                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,155,120,0.2)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = '#e0e0e0';
                                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}>
                                            <div style={{ textAlign: 'left' }}>
                                                <strong style={{ fontSize: '16px', color: '#333' }}>{local.local}</strong>
                                                <br />
                                                <small style={{ color: '#666' }}>
                                                    {local.comuna?.comuna || 'Sin comuna'} - {local.comuna?.region?.region || ''}
                                                </small>
                                                {local.direccion && (
                                                    <>
                                                        <br />
                                                        <small style={{ color: '#888' }}>{local.direccion}</small>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </ButtonGroup>
                            </div>
                        </div>
                    )}

                    {/* Mostrar local seleccionado - Solo para operaciones de recepción */}
                    {HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion' && localSeleccionado && (
                        <div className="mb-4">
                            <Alert variant="info">
                                <strong>Local seleccionado:</strong> {localSeleccionado.local}
                                <br />
                                <small>
                                    {localSeleccionado.comuna?.comuna} - {localSeleccionado.comuna?.region?.region}
                                </small>
                                <br />
                                <Button
                                    size="small"
                                    style={{ marginTop: '8px' }}
                                    onClick={() => {
                                        setLocalSeleccionado(null)
                                        setEnviar(false)
                                        setFiles([])
                                    }}>
                                    Cambiar local
                                </Button>
                            </Alert>
                        </div>
                    )}

                    {/* ============================================================ */}
                    {/* SELECTOR DE ARCHIVO */}
                    {/* Lógica condicional según FEATURE FLAG */}
                    {/* ============================================================ */}
                    
                    {/* Selector de Archivo - Condicional según tipo de operación y feature flag */}
                    {(
                        // Si la feature está habilitada, requiere local seleccionado para recepción
                        (HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion' && localSeleccionado) ||
                        // Si la feature está deshabilitada, permite subir directamente en recepción
                        (!HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion') ||
                        // Para operaciones de información, siempre permite subir directamente
                        tipoOperacion === 'informacion'
                    ) && !recibido && (
                        <>
                            <input
                                accept={SheetJSFT}
                                style={{ display: 'none' }}
                                id="contained-button-file"
                                type="file"
                                // multiple
                                disabled={Enviar}
                                onChange={event => {
                                    handleFile(event)
                                }}
                            />
                            <label htmlFor="contained-button-file">
                                <img
                                    alt=""
                                    style={{ width: 200 }}
                                    src="https://cdn1.iconfinder.com/data/icons/famous-brand-apps/100/_-04-512.png"
                                />
                                <Button
                                    style={{ backgroundColor: 'rgb(0, 155, 120)' }}
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    disabled={Enviar}>
                                    {Enviar ? 'Archivo cargado' : 'Seleccionar Archivo'}
                                </Button>
                            </label>
                        </>
                    )}

                    {/* ============================================================ */}
                    {/* BOTÓN ENVIAR */}
                    {/* Lógica condicional según FEATURE FLAG */}
                    {/* ============================================================ */}
                    
                    {/* Botón Enviar - Condicional según tipo de operación y feature flag */}
                    {Enviar && !recibido && (
                        // Si la feature está habilitada, requiere local seleccionado para recepción
                        (HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion' && localSeleccionado) ||
                        // Si la feature está deshabilitada, permite enviar directamente en recepción
                        (!HABILITAR_SELECCION_LOCAL && tipoOperacion === 'recepcion') ||
                        // Para operaciones de información, siempre permite enviar directamente
                        tipoOperacion === 'informacion'
                    ) && (
                        <>
                            <Button
                                className="mx-3 spread-font btn btn-primary"
                                variant="contained"
                                style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                                onClick={() => {
                                    if (path === 'faltantesKarri' || path === 'faltantesRipley') {
                                        fetchClientDataMassive(client)
                                    } else if (path === 'recepcionParis') {
                                        processParisData(client)
                                    } else {
                                        procesarData()
                                    }
                                }}>
                                ENVIAR
                            </Button>
                        </>
                    )}
                </>
            )}
            {path == 'cargaLlego' && (
                <>
                    <Button
                        className="mx-3 spread-font btn btn-primary"
                        variant="contained"
                        style={{ backgroundColor: 'rgb(0, 155, 120)', color: 'white' }}
                        onClick={() => {
                            fetchClientDataMassive(client)
                        }}>
                        Obtener los datos de hoy
                    </Button>
                </>
            )}
        </Col>
    )
}

export default UploadFile
